const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2e3ba095c44ad3d17f606d1ddb5e15f6f3ffb544"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"2e3ba095c44ad3d17f606d1ddb5e15f6f3ffb544"};
      